import { PackageOpen, Store, UsersRound } from "lucide-react";
import { Link, useLocation } from "wouter";

const OWNERSHIP_DESTINATIONS = [
  { href: "/app/packs", label: "Pack Opening", icon: PackageOpen },
  { href: "/app/marketplace", label: "Marketplace", icon: Store },
  { href: "/app/syndicates", label: "Syndicates", icon: UsersRound },
] as const;

export function OwnershipSubnav() {
  const [location] = useLocation();

  return (
    <nav aria-label="Ownership" className="packs-subnav">
      {OWNERSHIP_DESTINATIONS.map(({ href, icon: Icon, label }) => {
        const active = location.startsWith(href);
        return (
          <Link
            aria-current={active ? "page" : undefined}
            className={active ? "is-active" : undefined}
            href={href}
            key={href}
          >
            <Icon aria-hidden />
            <span>{label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
